/** @jsx jsx */
import React, { createRef, useEffect } from 'react'
import { Box, jsx, Flex } from 'theme-ui'
import useDocumentPosition from '../../hooks/useDocumentPosition'
import useReachCurrency from '../../hooks/useReachCurrency'
import { useWindowSize } from '../../hooks/useWindowSize'
import AddToCart from '../product/AddToCartButton'
import { ProductPrice } from '../product/ProductCard'
import Button from '../shared/Buttons/Button'

const LPButtonComponent = ({
  actionButton: { buttonLabel, buttonStyle, buttonSize, toSlug },
  productInfo,
  sticky,
  landingPageCta,
  useAddToCartBtn,
}) => {
  const { mobile } = useWindowSize()

  const ref = createRef()
  const { fixedPosition } = useDocumentPosition(ref)
  const isFixed = {
    position: 'fixed',
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 3,
    width: '100%',
    borderRadius: 0,
  }
  return (
    <Flex
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        padding: 25,
        marginTop: 25,
        background: 'white',
        ...(mobile && fixedPosition && sticky && isFixed),
      }}
    >
      {useAddToCartBtn ? (
        <LPButton
          buttonProps={{ buttonStyle, buttonSize, toSlug }}
          productInfo={productInfo}
          style={{ minWidth: '350px' }}
          paragraphOptions={{
            sx: {
              fontSize: 3,
            },
          }}
        />
      ) : (
        <Button
          to={toSlug || `products/${landingPageCta}`}
          sx={{ minWidth: '350px', minHeight: '60px' }}
          size={buttonSize || 'large'}
          variant={buttonStyle || 'default'}
          paragraphOptions={{
            sx: {
              fontSize: 3,
            },
          }}
        >
          {buttonLabel || 'Shop'} {productInfo && (productInfo.title || 'Now')}
        </Button>
      )}
      <Box ref={ref} />
    </Flex>
  )
}

export const LPButton = ({
  buttonProps: { buttonLabel, buttonStyle, buttonSize },
  productInfo,
  ...props
}) => {
  const {
    getRegionalPrice,
    getRegionalCompareAt,
    loaded,
    convertedCurrency,
    notUs,
  } = useReachCurrency(productInfo.shopifyProduct.variants)

  const regionalCompareAt = getRegionalCompareAt(0)
  const regionalPrice = getRegionalPrice(0)

  const price = regionalPrice || productInfo.shopifyProduct.variants[0].price
  const compareAt =
    regionalCompareAt || productInfo.shopifyProduct.variants[0].compareAtPrice

  return (
    <AddToCart
      size={buttonSize || 'large'}
      variant={buttonStyle || 'default'}
      title={
        buttonLabel ? (
          buttonLabel
        ) : (
          <Flex sx={{ justifyContent: 'center' }}>
            {`Buy Now - `}
            {'  '}
            <ProductPrice
              style={{ marginLeft: '5px' }}
              price={price}
              compareAtPrice={compareAt}
              currency={convertedCurrency}
              textColor="white"
              textStyles={{ fontSize: 3, fontWeight: 'semiBold' }}
            />
          </Flex>
        )
      }
      convertedPrice={price}
      convertedCompareAtPrice={compareAt}
      convertedCurrency={convertedCurrency}
      shopifyId={
        productInfo.shopifyProduct.variants.find(v => v.availableForSale)
          .shopifyId
      }
      availableForSale={productInfo.shopifyProduct.availableForSale}
      productType={productInfo.productType}
      buyNow
      {...props}
    />
  )
}

export default LPButtonComponent
